exports = module.exports = require("../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3WrfvKegKBcXhrDATzoRTr{width:100%;clear:both;font-size:18px;font-weight:600;color:var(--neutralPrimary)}html[dir] ._3WrfvKegKBcXhrDATzoRTr{border-top:1px solid var(--neutralLight);padding-top:20px}html[dir] ._3WrfvKegKBcXhrDATzoRTr .w0D62Wx8fLdJ2xJuRUUfB{margin-bottom:10px}", ""]);
// Exports
exports.locals = {
	"container": "_3WrfvKegKBcXhrDATzoRTr",
	"storageAccount": "w0D62Wx8fLdJ2xJuRUUfB"
};